var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.$style.root},[_c('main-form',{attrs:{"disabled":_vm.resultsVisible}}),(_vm.resultsVisible)?_c('export-results'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }